var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26231 8.0415H4.50281V7.07456H5.89219L4.82625 4.29019L5.706 3.9375L7.70288 9.15019L10.2909 9.16706L12.294 3.9375L13.1743 4.29019L12.1078 7.07456H13.4972V8.04206H11.7377L11.304 9.17269L13.5 9.18675L13.4944 10.1537L10.935 10.1374L9 15.1875L7.056 10.1132L4.5 10.0963L4.50563 9.12994L6.68475 9.144L6.26231 8.0415ZM8.07356 10.1194L9 12.537L9.92138 10.1312L8.07356 10.1194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVia);
export default __webpack_public_path__ + "static/media/via.9249c345beba17edc1626ebf78238b0d.svg";
export { ForwardRef as ReactComponent };